import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AppConfigsService } from '@core/app-configs/services/app-configs.service';

export const appMaintenanceGuard: CanMatchFn = (_route, segments) => {
    const appConfigsService = inject(AppConfigsService);
    const router = inject(Router);

    if (segments[0]?.path === 'service-unavailable') return true;

    return !!appConfigsService.appConfigs().maintenances?.app?.in_maintenance
        ? router.createUrlTree(['/service-unavailable'])
        : true;
};
